module.exports = __webpack_public_path__ + "img/header.0a0ee39b.png";